import axios from 'axios'
import store from '@/store'
import router from "@/router";
import {toast} from "../class/Notification";
import {findObjectIndex} from "../class/Converter";
import {queryBuilder, filters} from '../class/QueryFilter'

let filtersCopy = JSON.parse(JSON.stringify(filters))

const sendMessageDataShape = (form) => {
    let formData = new FormData();
    formData.append('message', form.message);

    if (form.chat_type != undefined) {
        formData.append('chat_type', form.chat_type);
    }

    if (form.subject != undefined) {
        formData.append('subject', form.subject);
    }

    for (let [index, value] of Object.entries(form.files)) {
        formData.append(`files[${index}]`, value);
    }

    if (form.group != undefined) {
        form.group.forEach((item, index) => {
            formData.append(`group[${index}][group_type]`, item.group_type);
            formData.append(`group[${index}][group_id]`, item.group_id);
            formData.append(`group[${index}][group_on]`, item.group_on);
        })
    }

    if (form.users != undefined) {
        form.users.forEach((item, index) => {
            formData.append(`users[${index}]`, item);
        })
    }

    formData.append('chat_token', form.chat_token);
    return formData;
}

export let ChatStatus = {
    0: 'منتظر پاسخ',
    1: 'پاسخ داده شده',
}

export let ChatType = {
    0: 'عمومی',
    1: 'خصوصی',
}

export default {
    namespaced: true,
    state: {
        chats: [],
        singleChat: [],
        chatMessages: [],
        singleChatUser: [],
        pagination: [],
        ...filtersCopy,
    },
    mutations: {
        setChats(state, chats) {
            state.chats = chats
        },
        setChatMessages(state, messages) {
            state.chatMessages = messages
        },
        setSingleChatUser(state, user) {
            state.singleChatUser = user
        },
        setSingleChat(state, chat) {
            state.singleChat = chat
        },
        setPagination(state, meta) {
            state.pagination = meta
        },
        setFilters(state, filter) {
            const keys = Object.keys(state.filters)
            for (let i in keys) {
                state.filters[filter.key] = filter.value;
                return
            }
        },
    },
    actions: {
        async getChats({commit, state}, page = 1) {
            const query = queryBuilder(state.filters)
            const res = await axios.get(`/chat?page=${page}&${query}`);
            const data = res.data.data;
            await commit('setChats', data.data)
            await commit('setPagination', data.meta)
            return res
        },
        async getSingleChat({commit, state}, form) {
            const query = queryBuilder(state.filters)
            const res = await axios.post(`/chat/history/${form.slug}?page=${form.page}&${query}`, form);
            const data = res.data.data;
            if (form.withoutState === undefined) {
                commit('setSingleChat', data.chat)
                commit('setChatMessages', data.data.reverse())
                commit('setSingleChatUser', data.user)
                commit('setPagination', data.meta)
            }
            return res
        },
        /*
        * if message was new we add it in front of the list otherwise end of the list.
        *  */
        addMessages({commit, state}, {messages, isNew = true}) {
            let currentMessages = state.chatMessages;
            messages.forEach(item => {
                if (isNew) {
                    currentMessages.push(item)
                } else {
                    currentMessages.unshift(item)
                }
            })
        },
        async sendMessage({commit, dispatch, state}, form) {
            const captcha = store.getters['Captcha/getCaptchaForUrl']
            form['chat_token'] = localStorage.getItem('chat_token')
            let reshapedForm = sendMessageDataShape(form)
            const res = await axios.post(`/chat/send-message/${form.slug}?${captcha}`, reshapedForm);
            const message = res.data.data;
            const messages = [message]
            if (form.withoutState === undefined) {
                dispatch('addMessages', {messages})
            }
            return res
        },
        async startNewChat({commit, dispatch, state}, form) {
            let reshapedForm = sendMessageDataShape(form)
            const res = await axios.post(`/chat/start`, reshapedForm);
            if (form.withoutState === undefined) {
                commit('setSingleChat', data.data)
            }
            return res
        },
        changeChatStatus({commit}, form) {
            return axios.put(`chat/${form.id}`, form)
        },
        async getUserChats({commit, state}, form) {
            const query = queryBuilder(state.filters)
            const res = await axios.get(`/chat/user/${form.user_id}?page=${form.page}&${query}`);
            const data = res.data.data;
            if (form.withoutState === undefined) {
                await commit('setChats', data.data)
                await commit('setPagination', data.meta)
            }
            return res
        },
        async getUserChatsWithToken({commit, state}, form) {
            const query = queryBuilder(state.filters)
            const res = await axios.get(`/chat/user/chat-token/${form.user_id}?page=${form.page}&${query}`);
            const data = res.data.data;
            if (form.withoutState === undefined) {
                await commit('setChats', data.data)
                await commit('setPagination', data.meta)
            }
            return res
        },
        getChatToken({commit}) {
            return localStorage.getItem('chat_token')
        },
        async checkChatToken({commit, dispatch}) {
            const chat_token = await dispatch('getChatToken');
            return chat_token != null
        },
        removeChatToken({commit}) {
            localStorage.removeItem('chat_token')
            return true
        },
        async checkUsersHaveChatBefore({commit}, form) {
            const res = await axios.post(`/chat/check-user-have-chat`, form);
            const data = res.data.data;
            return res
        },
        async sendSmsForChatUsers({commit}, form) {
            return await axios.post(`/chat/send-sms/${form.chat_id}`, form);
        },
    },
    getters: {
        getChats: state => state.chats,
        getChatUser: state => state.singleChatUser,
        getSingleChat: state => state.singleChat,
        getChatMessages: state => state.chatMessages,
        getPagination: state => state.pagination,
        getFilters: (state) => state.filters,
    }
}